// import { ShoppingCartIcon, UserIcon } from "@heroicons/react/outline";
// import logo from "../../assets/logo.png";
// import { useCartStore } from "../../store/cartStore";
// import CartDrawer from "./cartDrawer";
// import { useNavigate } from "react-router-dom";

// export default function Navbar() {
//   const toggleDrawer = useCartStore((s) => s.toggleDrawer);
//   const totalItems = useCartStore((s) => s.getTotalItems());
//   const navigate = useNavigate();

//   return (
//     <>
//       <div className="fixed top-0 left-0 w-full bg-black backdrop-blur-md z-20 flex items-center justify-between px-6 py-2">
//         {/* LEFT — LOGO (clicks to home) */}
//         <div className="flex items-center">
//           <button onClick={() => navigate("/tickets-store/")}>
//             <img
//               src={logo}
//               alt="Afrodise Logo"
//               className="h-6 md:h-8 object-contain hover:opacity-80 transition"
//             />
//           </button>
//         </div>

//         {/* RIGHT — ICONS */}
//         <div className="flex items-center gap-4">
//           {/* CART ICON WITH BADGE */}
//           <button
//             onClick={toggleDrawer}
//             className="relative text-white hover:text-green-400 transition"
//           >
//             <ShoppingCartIcon className="w-5 h-5" />
//             {totalItems > 0 && (
//               <span className="absolute -top-2 -right-2 w-4 h-4 bg-green-500 text-black text-[10px] font-bold rounded-full flex items-center justify-center">
//                 {totalItems > 9 ? "9+" : totalItems}
//               </span>
//             )}
//           </button>

//           <button className="text-white hover:text-green-400 transition">
//             <UserIcon className="w-5 h-5" />
//           </button>
//         </div>
//       </div>

//       {/* CART DRAWER */}
//       <CartDrawer />
//     </>
//   );
// }

import { ShoppingCartIcon, UserIcon } from "@heroicons/react/outline";
import logo from "../../assets/logo.png";
import { useCartStore } from "../../store/cartStore";
import { useUserStore } from "../../store/userStore";
import CartDrawer from "./cartDrawer";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const toggleDrawer = useCartStore((s) => s.toggleDrawer);
  const totalItems = useCartStore((s) => s.getTotalItems());
  const { isAuthenticated, user } = useUserStore();
  const navigate = useNavigate();

  const handleUserClick = () => {
    if (isAuthenticated) {
      navigate("/tickets-store/user");
    } else {
      navigate("/tickets-store/auth");
    }
  };

  return (
    <>
      <div className="fixed top-0 left-0 w-full bg-black backdrop-blur-md z-20 flex items-center justify-between px-6 py-2">
        {/* LEFT — LOGO */}
        <button onClick={() => navigate("/tickets-store/")}>
          <img
            src={logo}
            alt="Afrodise Logo"
            className="h-6 md:h-8 object-contain hover:opacity-80 transition"
          />
        </button>

        {/* RIGHT — ICONS */}
        <div className="flex items-center gap-4">

          {/* BUY TICKETS LINK */}
          <button
            onClick={() => navigate("/tickets-store/")}
            className="text-xs tracking-widest uppercase text-gray-400 hover:text-green-400 transition hidden md:block"
          >
            Buy Tickets
          </button>

          {/* FAQ LINK */}
          <button
            onClick={() => navigate("/tickets-store/faq")}
            className="text-xs tracking-widest uppercase text-gray-400 hover:text-green-400 transition hidden md:block mr-5"
          >
            FAQ
          </button>

          {/* CART */}
          <button
            onClick={toggleDrawer}
            className="relative text-white hover:text-green-400 transition"
          >
            <ShoppingCartIcon className="w-5 h-5" />
            {totalItems > 0 && (
              <span className="absolute -top-2 -right-2 w-4 h-4 bg-green-500 text-black text-[10px] font-bold rounded-full flex items-center justify-center">
                {totalItems > 9 ? "9+" : totalItems}
              </span>
            )}
          </button>

          {/* USER */}
          <button
            onClick={handleUserClick}
            className="flex items-center gap-2 text-white hover:text-green-400 transition"
          >
            <UserIcon className="w-5 h-5" />
            {isAuthenticated && user?.first_name && (
              <span className="text-xs text-green-400 hidden md:block">
                {user.first_name}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* CART DRAWER */}
      <CartDrawer />
    </>
  );
}
